import wrapPageElementWithTransition from "./src/helpers/wrapPageElement"

export const wrapPageElement = wrapPageElementWithTransition
